export default "__VITE_ASSET__CSYA4SQX__"